export default __webpack_public_path__ + "static/media/virtualWonders.0663e07d.gif";